import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';


import {ActivatedRoute, Router} from '@angular/router';
import {finalize, first} from 'rxjs/operators';
import {LOCAL_STORAGE, SESSION_STORAGE, StorageService} from 'ngx-webstorage-service';

import {SocialAuthService} from 'angularx-social-login';
import {GoogleLoginProvider} from 'angularx-social-login';
import {AuthenticationService} from '../authentication.service';
import {AlertService} from 'ngx-alerts';
import {NgxSpinnerService} from 'ngx-spinner';
import {MessagingService} from '../../../services/messaging.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss', '../../../../assets/fonts/font-awesome-4.7.0/css/font-awesome.min.css']
})
export class LoginComponent implements OnInit {

    loginForm: FormGroup;
    submitted = false;
    error = '';
    returnUrl: string;

    // set the currenr year
    year: number = new Date().getFullYear();

    dataForm: FormGroup;

    otpForm: FormGroup;

    isOTPSent = false;

    otpVerifyParams = {
        version: 'v3',
        isChannelUser: true
    };

    otpSendParams = {
        version: 'v3'
    };

    @ViewChild('otpInput') otpInput: ElementRef;

    // tslint:disable-next-line: max-line-length
    constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private router: Router,
                public authenticationService: AuthenticationService, private alertService: AlertService,
                private authService: SocialAuthService, @Inject(LOCAL_STORAGE) private storage: StorageService,
                private fb: FormBuilder, private spinner: NgxSpinnerService,
                private messagingService: MessagingService) {
    }

    ngOnInit() {
        document.body.removeAttribute('data-layout');
        document.body.classList.add('auth-body-bg');

        window.addEventListener('resize', this.resetHeight);
// called to initially set the height.
        this.resetHeight();

        // this.loginForm = this.formBuilder.group({
        //   email: ['admin@themesdesign.in', [Validators.required, Validators.email]],
        //   password: ['123456', [Validators.required]],
        // });

        console.log(this.storage.get('gs-loggedInUser'));
        if (this.storage.get('gs-loggedInUser')) {
            this.messagingService.requestPermission();
            this.router.navigate([this.returnUrl ? this.returnUrl : '/']);
        }
        this.buildForm();

        this.authService.authState.subscribe((user) => {
            console.log('===========');
            console.log(JSON.stringify(user));
            if (user) {
                this.dataForm.get('googleSignInToken').setValue(user.idToken);
                if (this.otpForm.value.type) {
                    this.dataForm.get('type').setValue(this.otpForm.value.type);
                }
                this.spinner.show();
                this.authenticationService.channelUserLogin(this.dataForm.value).pipe(finalize(() => this.spinner.hide())).subscribe(
                    (res: any) => {
                        console.log(JSON.stringify(res));
                        this.alertService.success(res['message']);
                        this.storage.set('gs-loggedInUser', res.channelUser);
                        this.storage.set('gs-loggedInUserData', res.user);
                        this.storage.set('gs-loggedInUserType', this.dataForm.value.type.replace('"'));
                        this.messagingService.requestPermission();
                        this.router.navigate([this.returnUrl ? this.returnUrl : this.storage.get('gs-loggedInUserType').toLowerCase() == 'fleet' ? '/map-dashboard' : '/']);
                    }, error => {
                        console.log(error);
                        this.alertService.danger(error['message']);
                    }
                );
                console.log('===========');
            }
        });


        // reset login status
        // this.authenticationService.logout();
        // get return url from route parameters or default to '/'
        // tslint:disable-next-line: no-string-literal
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || (this.storage.get('gs-loggedInUserType') && this.storage.get('gs-loggedInUserType').toLowerCase() == 'fleet' ? '/map-dashboard' : '/');
    }

    // convenience getter for easy access to form fields
    userTypes: any[] = [
        {'title': 'Service Center', 'type': 'Service Center'},
        {'title': 'Fleet', 'type': 'Fleet'},
        {'title': 'Collaborators', 'type': 'collaborators'},
        {'title': 'Driving School', 'type': 'drivingSchool'},
    ];

    get f() {
        return this.loginForm.controls;
    }

    /**
     * Form submit
     */
    onSubmit() {
        if (this.otpForm.invalid) {
            this.alertService.warning('Please Enter Valid Mobile Number');
            return;
        }
        this.submitted = true;
        if (!this.isOTPSent) {
            this.isOTPSent = true;
            this.sendOTP();
        } else {
            this.verifyOTP();
        }

        //
        // // stop here if form is invalid
        // if (this.loginForm.invalid) {
        //   return;
        // } else {
        //   if (environment.defaultauth === 'firebase') {
        //     this.authenticationService.login(this.f.email.value, this.f.password.value).then((res: any) => {
        //       this.router.navigate(['/']);
        //     })
        //       .catch(error => {
        //         this.error = error ? error : '';
        //       });
        //   } else {
        //     this.authFackservice.login(this.f.email.value, this.f.password.value)
        //       .pipe(first())
        //       .subscribe(
        //         data => {
        //           this.router.navigate(['/']);
        //         },
        //         error => {
        //           this.error = error ? error : '';
        //         });
        //   }
        // }
    }

    signInWithGoogle() {
        this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
    }

    private buildForm() {
        this.dataForm = this.fb.group({
            googleSignInToken: '',
            type: ['', Validators.required]
        });

        this.otpForm = this.fb.group({
            countryCode: '91',
            userPhoneNumber: ['', Validators.required],
            otp: '',
            loginUser: true,
            requestId: '',
            type: ''
        });
    }

    sendOTP() {
        this.spinner.show();
        this.authenticationService.sendOTP(this.otpForm.value, this.otpSendParams).pipe(finalize(() => this.spinner.hide())).subscribe(
            (res: any) => {
                this.alertService.success(res['message']);
                this.otpForm.get('requestId').setValue(res.requestId);
                if (this.dataForm.value.type) {
                    this.otpForm.get('type').setValue(this.dataForm.value.type);
                }
                setTimeout(() => this.otpInput.nativeElement.focus(), 1000);
            }, error1 => {
                console.error(error1);
                this.alertService.danger(error1.message ? error1.message : error1);
            }
        );
    }

    verifyOTP() {
        this.spinner.show();
        this.authenticationService.verifyOTP(this.otpForm.value, this.otpVerifyParams).pipe(finalize(() => this.spinner.hide())).subscribe(
            (res: any) => {
                this.alertService.success(res['message']);
                this.storage.set('gs-loggedInUser', res.channelUser);
                this.storage.set('gs-loggedInUserData', res.user);
                this.storage.set('gs-loggedInUserType', this.otpForm.value.type.replace('"'));
                this.messagingService.requestPermission();
                this.router.navigate([this.returnUrl ? this.returnUrl : this.storage.get('gs-loggedInUserType').toLowerCase() == 'fleet' ? '/map-dashboard' : '/']);
            }, error1 => {
                console.error(error1);
                this.alertService.danger(error1.message ? error1.message : error1);
            }
        );
    }

    resetHeight() {
        // reset the body height to that of the inner browser
        let e = document.getElementsByClassName('limiter');
        if (e && e.length) {
            e[0]['style'].height = window.innerHeight + 'px';
            e[0]['style'].maxHeight = window.innerHeight + 'px';
        }
    }
}
